import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import ReviewerCard from '../../Reviewers/ReviewerCard';

/**
 * FollowedReviewersList — the ติดตาม (Following) tab body.
 *
 * Presents the user's followed reviewers with the SAME purple ReviewerCard
 * used by the ผู้รีวิว tab, but without the search bar or the random
 * suggestion strip. Clicking a card selects that reviewer (the parent then
 * switches to the map view with that reviewer's items).
 */
const FollowedReviewersList = ({ creators = [], loading = false, language = 'TH', onSelect }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
        <CircularProgress size={26} sx={{ color: '#7c3aed' }} />
      </Box>
    );
  }

  if (!creators || creators.length === 0) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, textAlign: 'center' }}>
        <Typography sx={{ fontSize: '2.5rem', mb: 1 }}>👥</Typography>
        <Typography sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.9rem' }}>
          {language === 'TH' ? 'ยังไม่ได้ติดตามใคร' : language === 'CN' ? '尚未关注任何人' : 'Not following anyone yet'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
      {creators.map((creator) => (
        <ReviewerCard
          key={creator.id}
          reviewer={{
            ...creator,
            item_count: creator.item_count ?? creator.event_count ?? creator.review_count ?? 0,
          }}
          language={language}
          onClick={() => onSelect && onSelect(creator)}
        />
      ))}
    </Box>
  );
};

export default FollowedReviewersList;
